import { gameiomModel } from "gameiom/model/gameiom-model";
import { SymbolFooterComponent, SymbolFooterComponentConfig } from "slotworks/components/footer/symbol-footer-component";

export class AgsSymbolFooterComponent extends SymbolFooterComponent {
    constructor(config?: Partial<SymbolFooterComponentConfig>) {
        super(config);
    }

    public getForceCreditMode(): boolean {
        return !gameiomModel.displayCurrency || gameiomModel.shouldDisplayCredits();
    }
}